import React from "react";
import "./Campaigns.css";
import mainImg from "../../assets/Campaigns/SUNDAR/Copy of Sunder Main.jpg";
import proposalImg from "../../assets/Campaigns/SUNDAR/Copy of PROPOSAL.jpg";
import bridalRevealImg from "../../assets/Campaigns/SUNDAR/Copy of Drhg.jpg";
import mehendiImg from "../../assets/Campaigns/SUNDAR/Copy of Mehendi_.jpg";
import haldiImg from "../../assets/Campaigns/SUNDAR/Copy of HALDI.jpg";
import sisterBond from "../../assets/Campaigns/SUNDAR/Copy of SISTERS BOND.jpg"

import Liverimg from "../../assets/Campaigns/DTSHREYA/Copy of Liver.jpg";
import PCOSimg from "../../assets/Campaigns/DTSHREYA/Copy of PCOS.jpg";
import ORTHOimg from "../../assets/Campaigns/DTSHREYA/Copy of ORTHO.jpg";
import KIDNEYimg from "../../assets/Campaigns/DTSHREYA/Copy of Kidney (1).jpg";
import GYNACimg from "../../assets/Campaigns/DTSHREYA/Copy of Gynac 1.jpg";
import Diabetes from "../../assets/Campaigns/DTSHREYA/Diabetes.jpg";
const campaignGroups = [
    {
        title: "SUNDER VIVAH CAMPAIGN",
        eyebrow: "WEDDING FILM SERIES",
        subtitle: `A celebration of love, light, and timeless legacy. An ode to timeless weddings and timeless jewelry. I almost wrote "timeless." Again.`,

        items: [
            {
                title: "THE BEGINNING",
                category: "MAIN FILM",
                image: mainImg,
            },
            {
                title: "THE PROPOSAL",
                category: "PROPOSAL AD",
                image: proposalImg,
            },
            {
                title: "THE BRIDAL REVEAL",
                category: "DULHAN READY HOGI",
                image: bridalRevealImg,
            },
            {
                title: "MEHENDI MEMORIES",
                category: "MEHNDI",
                image: mehendiImg,
            },
            {
                title: "HALDI HUES",
                category: "HALDI",
                image: haldiImg,
            },
            {
                title: "A SISTER'S PROMISE",
                category: "SISTER'S BOND",
                image: sisterBond,
            },
        ],
    },

    {
        title: "DT. SHREYA CAMPAIGN",
        eyebrow: "WELLNESS CAMPAIGN SERIES",
        subtitle: `Health isn't built overnight. Neither is trust. A campaign that put sustainable wellness before shortcuts. Apparently having diet coke doesn't mean I am dieting.`,

        items: [
            {
                title: "HEALING THE LIVER",
                category: "LIVER",
                image: Liverimg,
            },
            {
                title: "BEYOND PCOS",
                category: "PCOS - PCOD",
                image: PCOSimg,
            },
            {
                title: "STRONGER EVERY STEP",
                category: "ORTHO",
                image: ORTHOimg,
            },
            {
                title: "KIDNEY CARE FIRST",
                category: "KIDNEY",
                image: KIDNEYimg,
            },
            {
                title: "WOMEN'S WELLNESS",
                category: "GYNAC",
                image: GYNACimg,
            },
            {
                title: "LIVING BEYOND DIABETES",
                category: "DIABETES",
                image: Diabetes,
            },
        ],
    },
];

const categories = [
    "CAMPAIGNS",
    "COMMERCIALS",
    "BRAND FILMS",
    "CORPORATE FILMS",
    "DOCUMENTARIES",
    "PODCASTS & INTERVIEWS",
    "EVENTS",
    "SOCIAL AND VERTICAL FILMS",
    "PHOTOGRAPHY CREATIVE",
    
];

function pad(num) {
    return String(num).padStart(2, "0");
}

function Campaigns() {
    const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};

    return (
        <main className="campaign-page">
            <div className="campaign-shell">
                <div className="campaign-content">
                    {campaignGroups.map((group, groupIndex) => (
                        <section className="campaign-group" key={group.title}>
                            {/* HEADER */}

                            <div className="campaign-header">
                                <div className="campaign-eyebrow">
                                    <span className="eyebrow-tick" />
                                    <span>{group.eyebrow}</span>
                                    <span className="eyebrow-index">
                                        N&deg;{pad(groupIndex + 1)}
                                    </span>
                                    <span className="eyebrow-tick" />
                                </div>

                                <h1 className="campaign-title">{group.title}</h1>

                                <div className="campaign-title-rule" />

                                <div className="campaign-subtitle">{group.subtitle}</div>
                            </div>

                            <div className="campaign-grid">
                                {group.items.map((item, itemIndex) => (
                                    <article
                                        className="campaign-card"
                                        key={item.title}
                                        tabIndex={0}
                                    >
                                        {/* REEL INDEX */}

                                        <div className="campaign-card-index">
                                            {pad(itemIndex + 1)}
                                            <span>/{pad(group.items.length)}</span>
                                        </div>

                                        {/* IMAGE */}

                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="campaign-card-image"
                                        />

                                        {/* DARK OVERLAY */}

                                        <div className="campaign-card-overlay"></div>

                                        {/* VIEWFINDER FRAME (signature hover mark) */}

                                        <div className="campaign-card-frame">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>

                                        {/* PLAY BUTTON */}

                                        <button
                                            type="button"
                                            className="campaign-play"
                                            aria-label={`Play ${item.title}`}
                                        >
                                            <span></span>
                                        </button>

                                        {/* CARD CONTENT */}

                                        <div className="campaign-card-info">
                                            <h2>{item.title}</h2>
                                            <p>{item.category}</p>
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </section>
                    ))}
                </div>

                {/* =========================
            BOTTOM CATEGORY NAV
        ========================= */}

                <nav className="campaign-category-bar">
                    {/* LEFT ARROW */}

                    <button
                        className="campaign-nav-arrow"
                        onClick={() => goToCategory("PODCASTS & INTERVIEWS")}
                        aria-label="Previous category"
                    >
                        &larr;
                    </button>

                    {/* CATEGORIES */}

                    <div className="campaign-category-list">
                        {categories.map((category) => (
                            <button
                                key={category}
                                type="button"
                                className={`campaign-category ${category === "CAMPAIGNS" ? "active" : ""
                                    }`}
                                onClick={() => goToCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </div>

                    {/* RIGHT ARROW */}

                    <button
                        className="campaign-nav-arrow"
                        onClick={() => goToCategory("COMMERCIALS")}
                        aria-label="Next category"
                    >
                        &rarr;
                    </button>
                </nav>
            </div>
        </main>
    );
}

export default Campaigns;